import { render, staticRenderFns } from "./AddCustomEmailTemplate.vue?vue&type=template&id=4b185452&scoped=true&"
import script from "./AddCustomEmailTemplate.vue?vue&type=script&lang=js&"
export * from "./AddCustomEmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomEmailTemplate.vue?vue&type=style&index=0&id=4b185452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b185452",
  null
  
)

/* custom blocks */
import block0 from "./AddCustomEmailTemplate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCol,VForm,VIcon,VRadio,VRadioGroup,VRow,VSelect,VTextField})
